import api from "!../../../../../../node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../../../../../../node_modules/css-loader/dist/cjs.js??clonedRuleSet-35.use[1]!../../../../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../../../../node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-35.use[2]!../../../../../../node_modules/sass-loader/dist/cjs.js??clonedRuleSet-35.use[3]!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./IFrame.vue?vue&type=style&index=0&id=dee55928&prod&lang=scss";

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



export default content.locals || {};